import { Fragment, h } from 'preact'
export const IconMore = ({ count, breakpoint }) => {
    // + {count - breakpoint} not using
    return (
        <div class="icon icon-more">
            +
        </div>
    )
}
